import { MarketTopAssetsCard } from '@/components';
import { NewsCard } from '@/components/';
import {
  PortfolioCard,
  TrendingYieldBearingAssetsCard,
} from '@/components/organisms';
import MostRecentTransactionsCard from '@/components/organisms/MostRecentTransactions/MostRecentTransactionsCard';
import APP_CONFIG from '@/config/app';
import { FC } from 'react';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const spacingConfig = {
  gap: `gap${APP_CONFIG.STYLES.MAIN_PADDING}`,
  columnGap: `gap${APP_CONFIG.STYLES.MAIN_PADDING}`,
};
const roundednessConfig = {
  roundedness: `rounded${APP_CONFIG.STYLES.MAIN_ROUNDEDNESS}`,
};
const HomeTemplate: FC = () => {
  return (
    <div
      className={`grid grid-cols-5 auto-rows-max grid-auto-flow-column 
        ${spacingConfig.gap} 
        ${roundednessConfig.roundedness} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      <div
        className={`col-span-3 flex flex-col
          ${spacingConfig.columnGap} 
          ${borderClassToVisualizeElementsAndSpacing}`}
      >
        <PortfolioCard showRewardsSummary showRewardsCondensedInformation />
        <MostRecentTransactionsCard />
      </div>
      <div
        className={`col-span-2 flex flex-col 
          ${spacingConfig.columnGap} 
          ${borderClassToVisualizeElementsAndSpacing}`}
      >
        <TrendingYieldBearingAssetsCard />
        <MarketTopAssetsCard limit={5} showAllDetails={false} />
        {APP_CONFIG.SHOW_NEWS && <NewsCard />}
      </div>
    </div>
  );
};
export default HomeTemplate;
